import { AutoCompleteInput } from "./Autocomplete";
import { withStyles, Button, CircularProgress } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
const styles = (theme) => ({
  searchButton: {
    fontSize: theme.textFontSize,
    flexGrow: 1,
    borderRadius: "unset",
    color: theme.TextColor,
    "&:focus": {
      border: `1px solid ${theme.HeaderSelectedText}`,
      background: "rgba(0, 0, 0, 0.08)",
    },
    "&:disabled": {
      color: theme.TextColor,
    },
    border: `1px solid ${theme.AppBGColor}`,
  },
  activeSelection: {
    color: theme.white,
    backgroundColor: theme.HeaderSelectedText,
    "&:hover": {
      backgroundColor: theme.HeaderSelectedText,
    },
    "&:focus": {
      backgroundColor: theme.HeaderSelectedText,
      opacity: 0.8,
    },
  },
  filterContainer: {
    display: "flex",
    marginBottom: 8,
  },
  button: {
    width: "15%",
    marginLeft: 4,
    height : 34,
    "&:disabled": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8,
    },
  },
  searchBoxWrapper: {
    width: "80%",
  },
  searchContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  circularProgress: {
    color: theme.white,
  },
});

const SearchBar = ({
  classes,
  filterOptions,
  handleFilterChange,
  selectedFilter,
  handleSelect,
  handleChange,
  searchedValue,
  options,
  placeholder,
  forwardRef,
  inputProps,
  showLoader,
  loadingMessage,
  noOptionsMsg,
  error,
  open,
  handleSearch,
  isReadOnly,
  autoFocus
}) => {
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && !error) {
      handleSearch?.();
    }
  };
  return (
    <div>
      <div className={classes.filterContainer}>
        {filterOptions.map((option) => (
          <Button
            className={`${classes.searchButton} ${
              selectedFilter === option.value ? classes.activeSelection : ""
            }`}
            key={option.label}
            variant="outlined"
            onClick={handleFilterChange(option.value)}
            disableRipple
            disabled={isReadOnly}
          >
            {option.label}
          </Button>
        ))}
      </div>
      <div className={classes.searchContainer}>
        <div className={classes.searchBoxWrapper}>
          <AutoCompleteInput
            forwardRef={forwardRef}
            items={options}
            placeholder={placeholder}
            value={searchedValue}
            handleChange={handleChange}
            handleSelect={handleSelect}
            inputProps={inputProps}
            showLoader={showLoader}
            loadingMessage={loadingMessage}
            onKeyPress={handleKeyPress}
            error={error}
            open={open}
            noOptionsMsg={noOptionsMsg}
            disabled={isReadOnly}
            autoFocus={autoFocus}
          />
        </div>
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          onClick={handleSearch}
          disabled={Boolean(error) || isReadOnly}
        >
          {showLoader ? (
            <CircularProgress
              size={16}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            <SearchIcon />
          )}
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(SearchBar);
